export default {
  methods: {

    draw_Forms() {

      this.canvasForms = this.svg
      .append('g')
      .attr('transform', `translate(0.5, 0.5)`)
      .style('font-family', 'roboto')

      if(this.title.main.visible == 'Y') {
        this.canvasForms
        .append('text')
        .attr('x', this.title.main.x) .attr('y', this.title.main.y + this.title.main.tSize*0.75)
        .attr('font-size', this.title.main.tSize)
        .attr('fill', this.title.main.tColor)
        .text(this.title.main.name)
      }

      if(this.title.sub.visible == 'Y') {
        this.canvasForms
        .append('text')
        .attr('x', this.title.sub.x) .attr('y', this.title.sub.y + this.title.sub.tSize*0.75)
        .attr('font-size', this.title.sub.tSize)
        .attr('fill', this.title.sub.tColor)
        .text(this.title.sub.name)
      }
      
      this.draw_ChartCanvas() // -----> draw_Elements.js
      this.draw_Timeline() // -----> draw_Timeline.js
      this.draw_barChart() // -----> draw_Chart.js
      if(this.secondary.visible == 'Y') this.draw_LineChart()
      

      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }
    },

  }
}
